import { useNavigate } from "react-router-dom";
import { IconShieldLock, IconHeadset } from "@tabler/icons-react";
import styles from "./VerificationGate.module.css";

const VerificationGate = ({ children }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrap}>
      <div className={styles.blurred} aria-hidden="true">
        {children}
      </div>

      <div className={styles.overlay}>
        <div className={styles.card}>
          <div className={styles.iconBadge}>
            <IconShieldLock size={26} />
          </div>
          <h3 className={styles.title}>Verification pending</h3>
          <p className={styles.body}>
            Your profile hasn't been verified yet. Once your account is verified, you'll get full access to this.
          </p>
          <button type="button" className={styles.button} onClick={() => navigate("/talent-support")}>
            <IconHeadset size={16} /> Contact Support
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationGate;
